export const filterSectionsWithoutExpenditures = (sections) => sections.filter(
  (section) => section.count_state_expenditures !== 0
);